import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getNewsContainer = store =>
  import(/* webpackChunkName: "news" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "news" */ './containers/NewsContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.NEWS_LIST_PATH,
      ROUTES.NEWS_DETAIL_PATH,
    ],
    component: AsyncComponent(() => getNewsContainer(store))
  }
])
